<template>
	<div class="supplements">
		<ul class="characteristic-bubble-list">
			<li
				v-for="characteristicItem in characteristicItems"
				:key="characteristicItem.id"
				:class="{'active': isSelected(characteristicItem)}"
			>
				<a href="#" @click.prevent="selectOrUnselect(characteristicItem)">
					<CharacteristicLabel
						:characteristic="characteristicItem"
						:label-type="labelType"
					/>
				</a>
			</li>
			<li v-if="nothingAllowed" :class="{'active': isIrrelevant}">
				<a href="#" @click.prevent="irrelevant">Egal</a>
			</li>
		</ul>
	</div>
</template>

<script>
import {mapState} from "vuex";
import {camelize} from "@/helper/String";
import {isDefined} from "@/helper/Value";
import CharacteristicLabel from "@/vue/characteristic/Label";
import _ from "lodash";

export default {

	components: {
		CharacteristicLabel,
	},

	props: {
		itemCharacteristicType: {
			type: Object,
			required: true,
		},
		nothingAllowed: {
			type: Boolean,
			required: true,
		},
		initialSelected: {
			type: Array,
			required: false,
		},
		labelType: {
			type: String,
			required: false
		}
	},

	mounted ()
	{
		this.emitChangeEvent();
	},

	data ()
	{
		return {
			selected: this.initialSelected,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		characteristicItems ()
		{
			return this.meta[camelize(this.itemCharacteristicType.type.id)];
		},
		isIrrelevant ()
		{
			return isDefined(this.selected) && this.selected.length === 0;
		}
	},

	methods: {
		characteristics (items)
		{
			return _.map(items, 'item');
		},
		irrelevant ()
		{
			this.selected = [];

			this.emitChangeEvent();
		},
		onChange (data)
		{
			this.selected = [];

			_.forEach(data, item =>
			{
				this.selected.push({
					item: item
				});
			});

			this.emitChangeEvent();
		},
		selectOrUnselect (characteristicItem)
		{
			if (this.isSelected(characteristicItem))
			{
				this.unselect(characteristicItem);
			}
			else
			{
				if (!this.selected)
				{
					this.selected = [];
				}

				this.selected.push({
					item: characteristicItem
				});
			}

			this.emitChangeEvent();
		},
		unselect (characteristicItem)
		{
			this.selected = _.filter(this.selected, item => item.item.id !== characteristicItem.id);
		},
		isSelected (characteristicItem)
		{
			return isDefined(
				_.find(this.selected || [], item => item.item.id === characteristicItem.id)
			);
		},
		emitChangeEvent ()
		{
			this.$emit('input', {
				itemCharacteristicType: this.itemCharacteristicType,
				items: this.selected,
			});
		}
	},
}
</script>
